import { Decimal, DecimalField } from "./basic";
import { BigType } from "../serialization/BigType";
export class Slot extends Decimal {
    constructor(value) {
        super(value);
    }
    static zero() {
        return Slot.SLOT_ZERO;
    }
    static of(raw) {
        return new Slot(raw);
    }
    static field(property) {
        return new SlotField(property);
    }
    replaceWithValue(value) {
        return Slot.of(value);
    }
}
Slot.SLOT_ZERO = Slot.of(0);
class SlotField extends DecimalField {
    constructor(property) {
        super(BigType.U64, property);
    }
    fromBig(big) {
        return Slot.of(big);
    }
}
//# sourceMappingURL=Slot.js.map